<a class="link__button" [class.dark]="isDark" [routerLink]="[link]">{{ name }} </a>
